import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'

type Props = {
  url: string
  title: string
  image: string
}

export const CategoryCard: React.FC<Props> = ({ url, title, image }) => {
  return (
    <figure className='block h-full'>
      <Link
        href={url}
        className='group flex h-full flex-col items-center justify-center space-y-2'
        data-tracking-level-3={title}
      >
        <picture className='block h-full w-full overflow-hidden rounded-2xl'>
          <source
            media='(max-width: 768px)'
            srcSet={ImageHelper.getImageUrl(image, '270_306')}
          />
          <Image
            src={
              ImageHelper.getImageUrl(image, 'm') || '/images/logo-mobile.svg'
            }
            alt={`Danh mục thời trang - ${title}`}
            width={280}
            height={380}
            sizes='(max-width: 768px) 100vw, 280px'
            className='object-cover object-bottom transition-transform duration-500 group-hover:scale-105'
            loading='lazy'
          />
        </picture>
        <p className='text-body-2 text-clip whitespace-nowrap font-criteria uppercase transition-colors duration-300 group-hover:text-primary'>
          {title}
        </p>
      </Link>
    </figure>
  )
}
